export default {
  // Componente visual - sem strings estáticas traduzíveis
}
